export interface S3Credentials {
	// Sig V2
	accessKeyId: string;
	basePath: string;
	s3Policy: string;
	s3Signature: string;
	uploadUrl: string;

	// Sig V4
	fields: {
		Policy: string;
		'X-Amz-Algorithm': string;
		'X-Amz-Credentials': string;
		'X-Amz-Date': string;
		'X-Amz-Signature': string;
		bucket: string;
		key: string;
	};
	url: string;
}

export interface S3PolicyResponse {
	credentials: S3Credentials;
	status: boolean;
}

export interface S3SignedUrlResponse {
	status: boolean;
	url: string;
}

export interface S3File {
	extension?: string;
	fileName?: string;
	s3Key: string;
	size?: number;
	url?: string;
}
